import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  position: relative;\n  overflow-x: hidden;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from "@/components";
import { PreviewDialogProvider } from "@/components/Search/PreviewDialogProvider";
import { ProductSearchListPage } from "@/components/Search/ProductSearchListPage";
import styled from "styled-components";
const ProductIndexNextPage = ()=>{
    return /*#__PURE__*/ _jsx(ProductSearchPageWrapper, {
        children: /*#__PURE__*/ _jsx(Container, {
            children: /*#__PURE__*/ _jsx(PreviewDialogProvider, {
                children: /*#__PURE__*/ _jsx(ProductSearchListPage, {})
            })
        })
    });
};
export var __N_SSP = true;
export default ProductIndexNextPage;
const ProductSearchPageWrapper = styled.div.withConfig({
    componentId: "sc-8582b4b9-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_0);
